var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIcHomeFillinline = function SvgIcHomeFillinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.985 28.21a1.03 1.03 0 00-1.035-1.035h-3.915A1.03 1.03 0 0019 28.21v8.445c0 1.03-.83 1.86-1.86 1.86H8.2c-1.03 0-1.86-.83-1.86-1.86V18.91c0-1.352.613-2.633 1.677-3.481l11.189-8.97a4.471 4.471 0 015.573 0l11.203 8.97a4.45 4.45 0 011.678 3.48v17.746c0 1.03-.83 1.86-1.86 1.86h-8.94c-1.11-.015-1.86-.765-1.875-1.86V28.21z",
    fill: "url(#ic_home_fill_inline_svg__paint0_linear_18942_138)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic_home_fill_inline_svg__paint0_linear_18942_138",
    x1: 37.66,
    y1: 22,
    x2: 6.34,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    stopColor: "#BC3A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#6B2D60"
  })))));
};
export default SvgIcHomeFillinline;